import { BuyDispatcher } from "./Variable";
import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../../../../react-core/Flux/BaseStore";

export interface BuyStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    data?: any;
}

export class BuyStoreStatic extends BaseStore<BuyStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(BuyDispatcher, (actionData) => this.onBuyStoreResponse(actionData));
    }

    public getLastResult(): BuyStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getData() {
        return this.getState().data;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): BuyStoreStaticState {
        return {
            actionType: ActionType.Loading,
            data: null,
            isLoading: false,
        };
    }

    private onBuyStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({ actionType: ActionType.Success, data: actionData.payload });
                break;
            case ActionType.Update:
                this.setState({ actionType: ActionType.Update, data: actionData.payload });
                break;
            case ActionType.Error:
                this.setState({ actionType: ActionType.Error });
                break;
            case ActionType.Loading:
                this.setState({ isLoading: actionData.payload, actionType: ActionType.Loading });
                break;
        }
    }
}
